import {
  Component,
  input,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class.big-avatar]="size() === 'big'" class="small-avatar avatar">
      {{ displayText() }}
    </div>
  `,
  styles: [
    `
      @use 'spacing/spacing-variables' as *;
      @use 'mixins/mixins' as *;

      .small-avatar {
        width: 40px;
        height: 40px;
        font-size: 16px;
        font-style: normal;
        font-weight: var(--mat-sys-medium-font-weight);
        line-height: 24px;
        letter-spacing: 0.15px;
        user-select: none;
      }

      .big-avatar {
        width: 127px;
        height: 127px;
        font-size: 57px;
        font-style: normal;
        font-weight: var(--mat-sys-regular-font-weight);
        line-height: 64px;
        letter-spacing: -0.25px;
        user-select: none;
      }

      .avatar {
        text-transform: uppercase;
        @include flex-center;
        justify-content: center;
        border-radius: 100%;
        background-color: var(--mat-sys-primary-container);
      }
    `,
  ],
})
export class AvatarComponent {
  avatar = input<string>();
  size = input<string>('small');
  userName = input.required<string>();

  displayText = computed(() => {
    if (this.avatar()) return this.avatar();

    if (this.userName())
      return this.getUserInitials();

    return '??';
  });

  
  
protected getUserInitials(): string {
    const fullName = this.userName();
    if (!fullName) return '';
    
    const words = fullName.trim().split(' ').filter(word => word.length > 0);
    if (words.length === 0) return '';
    
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();
    
    return firstInitial + lastInitial;
  }
}
